module.exports = __webpack_public_path__ + "static/media/rene_en_lucy_vecht_ervoor.19a70055.jpg";